var _linearGradient, _clipPath, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXampp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 20,
    role: "img",
    "aria-label": "Xampp",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Xampp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 67,
    height: 20,
    fill: "#fb7a24"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,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"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 425,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 390
  }, "Xampp"), /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 390
  }, "Xampp"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXampp);
export default __webpack_public_path__ + "static/media/xampp.fbcdd7819060ad59c71cf0874ae17698.svg";
export { ForwardRef as ReactComponent };